import React, { useEffect } from 'react';

interface NotificationProps {
  message: string;
  type: 'success' | 'error' | 'warning' | 'info';
  onClose: () => void;
  autoClose?: boolean;
  duration?: number;
}

const Notification: React.FC<NotificationProps> = ({
  message,
  type,
  onClose,
  autoClose = true,
  duration = 5000
}) => {
  useEffect(() => {
    if (autoClose) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [autoClose, duration, onClose]);

  const getStyles = () => {
    const baseStyles = {
      position: 'fixed' as const,
      top: '20px',
      right: '20px',
      padding: '16px 20px',
      borderRadius: '8px',
      maxWidth: '400px',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
      zIndex: 1000,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      animation: 'slideIn 0.3s ease-out'
    };

    const typeStyles = {
      success: {
        backgroundColor: '#d4edda',
        borderLeft: '4px solid #28a745',
        color: '#155724'
      },
      error: {
        backgroundColor: '#f8d7da',
        borderLeft: '4px solid #dc3545',
        color: '#721c24'
      },
      warning: {
        backgroundColor: '#fff3cd',
        borderLeft: '4px solid #ffc107',
        color: '#856404'
      },
      info: {
        backgroundColor: '#cce7ff',
        borderLeft: '4px solid #007bff',
        color: '#004085'
      }
    };

    return { ...baseStyles, ...typeStyles[type] };
  };

  return (
    <>
      <style>
        {`
          @keyframes slideIn {
            from {
              transform: translateX(100%);
              opacity: 0;
            }
            to {
              transform: translateX(0);
              opacity: 1;
            }
          }
        `}
      </style>
      <div style={getStyles()}>
        <span>{message}</span>
        <button
          onClick={onClose}
          style={{
            background: 'none',
            border: 'none',
            fontSize: '18px',
            cursor: 'pointer',
            marginLeft: '12px',
            opacity: 0.7
          }}
          aria-label="Close notification"
        >
          ×
        </button>
      </div>
    </>
  );
};

export default Notification;